import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Admin } from './admin.model';
import { Observable } from 'rxjs/Observable';
import { Restangular } from 'ngx-restangular';

@Injectable()
export class AdminService {
    constructor(private restangular: Restangular) {
    }

    getAllAdmins(): Observable<any> {
        return this.restangular.all("users").getList();
    }

    getAdmin(id: number): Observable<any> {
        return this.restangular.one('users/' + id).customGET("");
    }

    createAdmin(admin: any): Observable<any> {
        let requestData = {
            clientId: admin.clientId,
            username: admin.username,
            password: admin.password,
            apiSecret: admin.api_secret,
            name: admin.name,
            email: admin.email,
            userGroupId: admin.userGroupId,
            hasAdminRole: admin.role === 'ROLE_ADMIN' ? true : false
        };

        return this.restangular.all("users").post(requestData);
    }

    updateAdmin(id: number, admin: any): Observable<any> {
        let requestData = {
            clientId: admin.clientId,
            name: admin.name,
            username: admin.username,
            apiSecret: admin.api_secret,
            email: admin.email,
            enabled: admin.blocked ? false : true,
            hasAdminRole: admin.role === 'ROLE_ADMIN' ? true : false,
            userGroupId: admin.userGroupId
        };

        return this.restangular.one("users/" + id).customPUT(requestData);
    }

    public resetPassword(admin: any, password: any): Observable<any> {
        const id = admin.id;
        let requestData = {
            password: password
        };
        return this.restangular.one('users/reset/password/' + id).customPOST(requestData);
    }

    fetchLoggedinUser(): Observable<any> {
        return this.restangular.one("users/loggedin").customGET("");
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/pages/admin/admin.service.ts